import {
    ableProps,
    ablePropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'text',
        label: '单选节点文字',
        type: 'string',
    },
];

export const init = () => ({
    ...ablePropsInit,
    text: '',
});

export const name = '单选节点';

export const component = 'mobile-general-form-node-radio';

export const events = [
    // 'click',
    ...baseEvents,
];
